import { PropertyConfig, PropertyOptionsDuration } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { Comparator, CompareValidator } from "@cervval.js/common/src/services/validation.impl/validators/compare.validator";
import { MinValueValidator } from "@cervval.js/common/src/services/validation.impl/validators/minValue.validator";
import { RequiredValidator } from "@cervval.js/common/src/services/validation.impl/validators/required.validator";
import { validatorEntry } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { SECONDS_IN_ONE_MINUTE } from "@cervval.js/common/src/tools/time.tools";
import { toTimestamp, UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools.definitions";
import { BookingProduct } from "../data/booking.dto";
import { I18nPropertyConfig } from "./propertyConfig.i18n";

/** Product override PC for booking session */
export function getProductPropertyConfig(): PropertyConfig<PropertyConfigType, PropertyOptionsDuration>[] {
    const i18n = I18nPropertyConfig().product;
    return [
        {
            label: i18n.name,
            propertyName: keyof<BookingProduct>("name"),
            typeUid: PropertyConfigType.STRING,
            validators: {
                ...validatorEntry(RequiredValidator, true)
            }
        },
        {
            label: i18n.duration,
            propertyName: keyof<BookingProduct>("duration"),
            typeUid: PropertyConfigType.DURATION,
            options: {
                pickerOptions: {
                    useSeconds: true,
                    enableDurationSelectors: false // TODO Le picker casse l'affichage => à changer
                }
            },
            validators: {
                ...validatorEntry(RequiredValidator, true),
                ...validatorEntry(CompareValidator, {
                    comparator: Comparator.GREATER_OR_EQUAL,
                    value: toTimestamp(15 * SECONDS_IN_ONE_MINUTE),
                    valueFormatter: (value: UnixTimestamp) => {
                        const durationInMinutes = value / 60;
                        return durationInMinutes.toFixed(0) + " " + i18n.durationWeakUnitPlural;
                    }
                })
            }
        }, {
            label: i18n.price,
            propertyName: keyof<BookingProduct>("price"),
            typeUid: PropertyConfigType.NUMBER,
            options: {
                suffix: "€"
            },
            validators: {
                ...validatorEntry(RequiredValidator, true),
                ...validatorEntry(MinValueValidator, 0)
            }
        },
        {
            label: i18n.description,
            propertyName: keyof<BookingProduct>("description"),
            typeUid: PropertyConfigType.TEXTAREA,
            validators: {
                ...validatorEntry(RequiredValidator, true)
            }
        }
    ];
}